/* Toggle pill button with aria-pressed for multi-select toggle groups.
   Variants: brand (violet) and amber for different semantic contexts. */
import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { clsx } from 'clsx';

interface TogglePillProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected: boolean;
  variant?: 'brand' | 'amber';
}

const TogglePill = forwardRef<HTMLButtonElement, TogglePillProps>(
  ({ selected, variant = 'brand', children, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        aria-pressed={selected}
        className={clsx(
          'px-2.5 py-1 min-h-[44px] items-center justify-center text-caption rounded-full border transition-colors',
          selected
            ? variant === 'amber'
              ? 'bg-amber-100 border-amber-300 text-amber-800 dark:bg-amber-900/30 dark:border-amber-700 dark:text-amber-300'
              : 'bg-brand-100 border-brand-300 text-brand-800 dark:bg-brand-900/30 dark:border-brand-700 dark:text-brand-300'
            : 'bg-slate-50 border-slate-200 text-slate-600 hover:border-slate-300 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-400 dark:hover:border-slate-500',
          className
        )}
        {...props}
      >
        {children}
      </button>
    );
  }
);

TogglePill.displayName = 'TogglePill';

export default TogglePill;
